module.exports = __webpack_public_path__ + "img/RV.db95aa70.png";